import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Invoice, OrderPayment } from "../../OrderMFE/Invoice/types/invoice";

export interface InvoiceState {
  invoiceList: Invoice[];
  invoiceDetail: Invoice | null;
  invoicePaymentList: OrderPayment[];
  invoicePaymentDetail: OrderPayment | null;
}

const initialState: InvoiceState = {
  invoiceList: [],
  invoiceDetail: null,
  invoicePaymentList: [],
  invoicePaymentDetail: null
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoiceList: (state, action: PayloadAction<Invoice[]>) => {
      state.invoiceList = action.payload;
    },
    setInvoiceDetail: (state, action: PayloadAction<Invoice | null>) => {
      state.invoiceDetail = action.payload;
    },
    resetInvoiceDetail: (state) => {
      state.invoiceDetail = null;
    },
    setInvoicePaymentList: (state, action: PayloadAction<OrderPayment[]>) => {
      state.invoicePaymentList = action.payload;
    },
    setInvoicePaymentDetail: (
      state,
      action: PayloadAction<OrderPayment | null>
    ) => {
      state.invoicePaymentDetail = action.payload;
    },
    resetInvoicePaymentDetail: (state) => {
      state.invoicePaymentDetail = null;
    }
  }
});

export const {
  setInvoiceList,
  setInvoiceDetail,
  resetInvoiceDetail,
  setInvoicePaymentList,
  setInvoicePaymentDetail,
  resetInvoicePaymentDetail
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
